import {Component} from '@angular/core';

@Component({
    selector: 'app-gallery',

    templateUrl: './gallery.component.html',
    styleUrl: './gallery.component.css'
})
export class GalleryComponent {

}
